const MINUTE = 60 * 1000;
export const BREAKPOINT_DEFAULT_LEASE_MS = 20 * MINUTE; // 20 minutes
export const BREAKPOINT_RENEW_INCREMENT_MS = 10 * MINUTE; // 10 minutes
export const BREAKPOINT_MAX_REMAINING_MS = 20 * MINUTE; // 20 minutes
export function isSameBreakpoint(a, b) {
    if (!a || !b) {
        return false;
    }
    if (a.type !== b.type) {
        return false;
    }
    if (a.id !== b.id) {
        return false;
    }
    if (isHookBreakpointConfig(a) && isHookBreakpointConfig(b)) {
        return a.position === b.position;
    }
    return true;
}
function isHookBreakpointConfig(config) {
    return config.type === 'hook';
}
export function cloneBreakpointQueue(queue) {
    return Array.isArray(queue) ? queue.map((entry) => (Object.assign({}, entry))) : [];
}
export function markQueueSkipped(queue, startIndex, options = {}) {
    var _a;
    const updated = cloneBreakpointQueue(queue);
    const { fallbackHitAt } = options;
    if (startIndex < 0 || startIndex >= updated.length) {
        return updated;
    }
    const current = updated[startIndex];
    const hitAt = (_a = current.hitAt) !== null && _a !== void 0 ? _a : fallbackHitAt;
    updated[startIndex] = Object.assign(Object.assign(Object.assign({}, current), { skipped: true }), (hitAt ? { hitAt } : {}));
    for (let i = startIndex + 1; i < updated.length; i += 1) {
        if (!updated[i].hitAt) {
            updated[i] = Object.assign(Object.assign({}, updated[i]), { skipped: true });
        }
    }
    return updated;
}
